export default "__VITE_ASSET__8d4ac6cf__"